module.exports = __webpack_public_path__ + "static/media/testad2.d2e9b574.jpg";